import { useAirdropConfirmPage} from "./logic";
import { AirdropConfirmPageTemplate } from "./template";

export const AirdropConfirmPage = () => {
    const props = useAirdropConfirmPage();
    return (
        <AirdropConfirmPageTemplate {...props} />
    )
}